import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { RoleService } from 'src/app/services/role.service';
import { TeamService } from 'src/app/services/team.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})

export class TeamsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  availableClasses: string[] = ["body-dark", "body-white", "colorful"];
  currentClassIdx: number = 0;
  bodyClass: string;
  public loading: boolean;
  public errorMessage: string;
  public teamList: any[] = [];

  constructor(private renderer: Renderer2, private teamService: TeamService, private router: Router,private roleService: RoleService) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();    
  }

  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute2(this.router.url);
    this.getTeams();
  }

  changeBodyClass() {
    this.renderer.addClass(document.body, "teamsPage");
    // get html body element
    const bodyElement = document.body;
    if (bodyElement) {
      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];
      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);
      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }

  getTeams() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.teamService.getTeamListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.loading = false;
      this.teamList = data.data.items;
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  onClickLogo(id) {
    this.router.navigate(["/team-details/" + id]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.renderer.removeClass(document.body, 'teamsPage');
  }

}